<template>
  <div>
    <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12">
      <div class="row">
        <div class="col-xs-12">
          <div class="row">
            <div class="col-xs-8">
              <div class="box box-primary">
                <div class="box-header with-border">
                  <h3 class="box-title"><i class="fa fa-building-o mr-5"></i>{{companyInfo.name}}</h3>
                  <div class="box-tools pull-right">
                    <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
                  </div>
                </div>
                <!--<template v-if="fullLoading">
                  <div class="row">
                    <div class="col-xs-12 text-center">
                      <img class="loading-gif" src="/static/img/blabla.svg"/>
                    </div>
                  </div>
                </template>-->
                <template>
                  <div class="box-body">
                    <div class="row">
                      <div class="col-xs-12">
                        <div class="row">
                          <div class="col-xs-6">
                            <div class="form-group">
                              <label>Organisation #</label>
                              <input disabled data-vv-as="Organisation Number" data-vv-scope="companyInfo" :class="{'form-control': true, 'form-control-danger': errors.has('companyInfo.org') }" name="organisation_number" placeholder="Organisation Number" type="text" v-model="companyInfo.organisation_number">
                              <span v-show="errors.has('companyInfo.organisation_number')" class="small text-danger">{{ errors.first('companyInfo.organisation_number') }}</span>
                            </div>
                          </div>
                          <div class="col-xs-6">
                            <div class="form-group">
                              <label>{{'company_name' | translate}}</label>
                              <input disabled v-validate="'required'" data-vv-scope="companyInfo" data-vv-as="Name" :class="{'form-control': true, 'form-control-danger': errors.has('companyInfo.name') }" name="name" :placeholder="'company_name' | translate" type="text" v-model="companyInfo.name">
                              <span v-show="errors.has('companyInfo.name')" class="small text-danger">{{ errors.first('companyInfo.name') }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr>
                    <div class="row">
                      <div class="col-md-6 col-xs-12 text-center-xs">
                        <h5>{{'company_information' | translate}}:</h5>
                        <div class="row">
                          <div class="col-xs-6">
                            <p>
                              {{companyInfo.inv_company}}<br>
                              {{companyInfo.inv_first_name}} {{companyInfo.inv_last_name}}<br>
                              {{companyInfo.inv_street}}<br>
                              {{companyInfo.inv_postcode}} {{companyInfo.inv_city}}<br>
                              {{'sales_tax' | translate}}.: <strong>{{companyInfo.tax_number}}</strong><br/>
                            </p>
                          </div>
                          <div class="col-xs-6">
                            <p>
                              <a :href="`mailto:${companyInfo.inv_email}`">{{companyInfo.inv_email}}</a><br>
                              <i class="fa fa-phone mr-5"></i><a :href="`tel:${companyInfo.telephone}`">{{companyInfo.telephone}}</a><br>
                              <template v-if="companyInfo.mobile !==  ''">
                                <i class="fa fa-mobile mr-5"></i><a :href="`tel:${companyInfo.mobile}`">{{companyInfo.mobile}}</a><br>
                              </template>
                              <a target="_blank" class="text-bold" :href="getUrl(companyInfo.homepage)">{{'homepage' | translate}}</a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-xs-12 text-center-xs text-right">
                        <h5>{{'qb_contact' | translate}}:</h5>
                        <p>
                        <div>
                          <template v-if="toggle.phone">
                            <div class="input-group">
                              <input type="text" :disabled="loading.phone" v-model="companyInfo.qb_phone_contact" class="form-control">
                              <span class="input-group-btn"><button :disabled="loading.phone" class="btn btn-success" @click="() => {sendEdit(companyInfo.id, {qb_phone_contact: companyInfo.qb_phone_contact}, 'phone')}"> <i :class="[loading.phone ? 'fa fa-spinner fa-spin' : 'fa fa-check ml-5 mr-5']"></i></button></span>
                            </div>
                          </template>
                          <template v-else>
                            <i class="fa fa-phone mr-5"></i><a :href="`tel:${companyInfo.qb_phone_contact}`">{{companyInfo.qb_phone_contact}}</a> <button class="btn btn-xs btn-info ml-5" @click="() => {toggle.phone = true}"><i class="fa fa-edit ml-5 mr-5"></i></button>
                          </template>
                        </div>
                        <br>
                        <div class="mt-5">
                          <template v-if="toggle.mail">
                            <div class="input-group">
                              <input type="text" :disabled="loading.mail" v-model="companyInfo.qb_email_contact" class="form-control">
                              <span class="input-group-btn"><button :disabled="loading.mail" class="btn btn-success" @click="() => {sendEdit(companyInfo.id, {qb_email_contact: companyInfo.qb_email_contact}, 'mail')}"><i :class="[loading.mail ? 'fa fa-spinner fa-spin' : 'fa fa-check ml-5 mr-5']"></i></button></span>
                            </div>
                          </template>
                          <template v-else>
                            <i class="fa fa-at mr-5"></i><a :href="`mailto:${companyInfo.qb_email_contact}`">{{companyInfo.qb_email_contact}}</a> <button class="btn btn-xs btn-info ml-5" @click="() => {toggle.mail = true}"><i class="fa fa-edit ml-5 mr-5"></i></button>
                          </template>
                        </div>
                        <br>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="box-footer">
                    <div class="row">
                      <div class="col-xs-12">
                        <button data-toggle="collapse" data-target="#editCompany" type="button" class="btn btn-flat no-margin pull-right btn-info"><i class="fa fa-edit mr-5"></i>{{'edit' | translate}}</button>
                        <router-link :to="`/accounting/companies/${$route.params.id}/fees`"><button type="button" class="btn btn-flat pull-right mr-5 btn-warning"><i class="fa fa-edit mr-5"></i>{{'fees' | translate}}</button></router-link>
                      </div>
                    </div>
                    <div class="collapse" id="editCompany">
                      <div class="row">
                        <div class="col-md-12">
                          <h4 class=""><i class="fa fa-info-circle mr-5"></i>{{'company_info' | translate}}</h4>
                          <hr>
                          <div class="row">
                            <div class="col-xs-12">
                              <div class="form-group">
                                <label for="inv_company">{{'company' | translate}}:</label>
                                <input v-validate="'required'" data-vv-scope="companyInfo" data-vv-as="Company Invoice" class="form-control" name="inv_company" :placeholder="'company' | translate" type="text" v-model="companyInfo.inv_company">
                                <span v-show="errors.has('companyInfo.inv_company')" class="small text-danger">{{ errors.first('companyInfo.inv_company') }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6 col-sm-12">
                              <div class="form-group">
                                <label for="inv_first_name">{{'first_name' | translate}}:</label>
                                <input class="form-control" v-validate="'required'" data-vv-scope="companyInfo" data-vv-as="First Name" name="inv_first_name" placeholder="First Name" type="text" v-model="companyInfo.inv_first_name">
                                <span v-show="errors.has('companyInfo.inv_first_name')" class="small text-danger">{{ errors.first('companyInfo.inv_first_name') }}</span>
                              </div>
                            </div>
                            <div class="col-md-6 col-sm-12">
                              <div class="form-group">
                                <label for="inv_last_name">{{'last_name' | translate}}:</label>
                                <input v-validate="'required'" data-vv-scope="companyInfo" data-vv-as="Last Name" class="form-control" name="inv_last_name" placeholder="Last Name" type="text" v-model="companyInfo.inv_last_name">
                                <span v-show="errors.has('companyInfo.inv_last_name')" class="small text-danger">{{ errors.first('companyInfo.inv_last_name') }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xs-12">
                              <div class="form-group">
                                <label for="inv_street">{{'street' | translate}} &amp; Hausnr:</label>
                                <input v-validate="'required'" data-vv-scope="companyInfo" data-vv-as="Street" class="form-control" name="inv_street" :placeholder="'street' | translate" type="text" v-model="companyInfo.inv_street">
                                <span v-show="errors.has('companyInfo.inv_street')" class="small text-danger">{{ errors.first('companyInfo.inv_street') }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-3 col-sm-12">
                              <div class="form-group">
                                <label for="inv_postcode">{{'zip_code' | translate}}:</label>
                                <input v-validate="'required'" data-vv-scope="companyInfo" data-vv-as="Zip Code" class="form-control" name="inv_postcode" placeholder="Zip Code" type="text" v-model="companyInfo.inv_postcode">
                                <span v-show="errors.has('companyInfo.inv_postcode')" class="small text-danger">{{ errors.first('companyInfo.inv_postcode') }}</span>
                              </div>
                            </div>
                            <div class="col-md-9 col-sm-12">
                              <div class="form-group">
                                <label for="inv_city">{{'city' | translate}}:</label>
                                <input v-validate="'required'" data-vv-scope="companyInfo" data-vv-as="City" class="form-control" name="inv_city" :placeholder="'city' | translate" type="text" v-model="companyInfo.inv_city">
                                <span v-show="errors.has('companyInfo.inv_city')" class="small text-danger">{{ errors.first('companyInfo.inv_city') }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xs-12">
                              <div class="form-group">
                                <label for="tax_number">{{'tax_number' | translate}}:</label>
                                <input v-validate="'required'" data-vv-scope="companyInfo" data-vv-as="USt-IdNr." class="form-control" name="tax_number" placeholder="Ust-IdNr." type="text" v-model="companyInfo.tax_number">
                                <span v-show="errors.has('companyInfo.tax_number')" class="small text-danger">{{ errors.first('companyInfo.tax_number') }}</span>
                              </div>
                            </div>
                          </div>
                          <hr>
                          <div class="row">
                            <div class="col-xs-12">
                              <div class="form-group">
                                <label for="inv_email">{{'inv_email' | translate}}:</label>
                                <input v-validate="'required|email'" data-vv-as="Email" data-vv-scope="companyInfo" class="form-control" name="inv_email" placeholder="Email" type="text" v-model="companyInfo.inv_email">
                                <span v-show="errors.has('companyInfo.inv_email')" class="small text-danger">{{ errors.first('companyInfo.inv_email') }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6 col-sm-12">
                              <div class="form-group">
                                <label for="telephone">{{'phone_number' | translate}}:</label>
                                <input class="form-control" id="telephone" placeholder="Telephone" type="text" v-model="companyInfo.telephone">
                              </div>
                            </div>
                            <div class="col-md-6 col-sm-12">
                              <div class="form-group">
                                <label for="mobile">{{'mobile_number' | translate}}:</label>
                                <input class="form-control" id="mobile" placeholder="Mobile" type="text" v-model="companyInfo.mobile">
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xs-12">
                              <div class="form-group">
                                <label for="homepage">{{'homepage' | translate}}:</label>
                                <input class="form-control" id="homepage" placeholder="Homepage" type="text" v-model="companyInfo.homepage">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xs-12 text-right">
                        <button :disabled="errors.any('companyInfo')" @click="updateData(companyInfo)" class="btn btn-flat btn-success">
                          <i class="fa fa-save mr-5"></i>{{'submit' | translate | capitalize}}
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="col-xs-4">
              <div class="box box-primary">
                <div class="panel box">
                  <div class="box-header with-border">
                    <a @click="type = 'barcode'" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" class="" aria-expanded="false">
                      <strong><i class="fa fa-barcode mr-5"></i>Barcode {{'configuration' | translate}}</strong>
                    </a>
                  </div>
                  <div id="collapseThree" class="panel-collapse collapse in" aria-expanded="false">
                    <template v-if="fullLoading">
                      <div class="row">
                        <div class="col-xs-12 text-center">
                          <img class="loading-gif" src="/static/img/blabla.svg"/>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="box-body">
                      <multiselect @select="buildString" :options="placeholders" placeholder="Select placeholders" :custom-label="customLabel" label="label" track-by="id"></multiselect>
                      <div class="input-group pt-10">
                        <span class="input-group-addon">{{'type' | translate}}:</span>
                        <select class="form-control" @change="erpConf.barcode_content = ''" v-model="erpConf.barcode_type">
                          <option class="normal" value="code39">Code39</option>
                          <option class="normal" value="code93">Code93</option>
                          <option class="normal" value="code128">Code128</option>
                        </select>
                      </div>
                      <div class="row">
                        <div class="col-xs-12 pt-10">
                          <div class="input-group">
                            <span class="input-group-addon">Characters:</span>
                            <input v-validate="{regex: regex[erpConf.barcode_type] }" data-vv-as="Barcode Char" data-vv-scope="barcodeForm" class="form-control" name="barcode" type="text" v-model="barcodeChar" @blur="buildString({label:barcodeChar}, 0)">
                          </div>
                          <span v-show="errors.has('barcodeForm.barcode')" class="small text-danger">{{ errors.first('barcodeForm.barcode') }}</span>
                        </div>
                      </div>
                      <template v-if="erpConf.barcode_content && erpConf.barcode_content.length > 0">
                        <hr>
                        <h5>Final Barcode:</h5>
                        <br>
                        <div class="row">
                          <div class="col-xs-12">
                            <span>{{erpConf.barcode_content}}</span>
                          </div>
                        </div>
                        <div class="row pt-10">
                          <div class="col-xs-12">
                            <b-btn class="btn btn-sm btn-warning" @click="resetBarcode"><i class="fa fa-eraser mr-5"></i>Clear Code</b-btn>
                          </div>
                        </div>
                      </template>
                      <div class="row">
                        <div class="col-xs-12 mt-10">
                          <button :disabled="errors.any('barcodeForm')" @click="updateData(erpConf)" class="btn btn-success btn-flat no-margin pull-right"><i class="fa fa-save mr-5"></i>{{'submit' | translate}}</button>
                        </div>
                      </div>
                    </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6">
              <div class="box box-primary">
                <div class="box-header with-border">
                  <i class="fa fa-credit-card mr-5"></i>Warentrading
                </div>
                <div class="box-body">
                  <template v-if="wTLoading">
                    <img class="wt-loading-gif" src="/static/img/blabla.svg"/>
                  </template>
                  <div class="row" v-else>
                    <div class="col-xs-12">
                      <div class="input-group" style="width: 100%;">
                        <div class="input-group-addon">
                          <span>C-ID</span>
                        </div>
                        <input type="text" class="form-control" v-model="wTrade.customers_cid" :disabled="wTrade.flag === 1">
                        <div class="input-group-btn">
                          <span :class="['btn', wTrade.flag ? 'btn-success' : 'btn-danger', 'btn-flat', 'active']"><i :class="['fa', 'mr-5', wTrade.flag ? 'fa-check' : 'fa-ban']"></i>{{wTrade.flag ? 'is_active' : 'inactive' | translate}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box-footer" v-if="!wTLoading">
                  <div class="col-xs-12 text-right pull-right">
                    <button @click="postWT(1)" class="btn btn-flat btn-success" v-if="wTrade.flag === 0" :disabled="wTrade.customers_cid === ''">
                      <i class="fa fa-check mr-5"></i>{{'activate' | translate | capitalize}}
                    </button>
                    <button @click="postWT(0)" class="btn btn-flat btn-danger" :disabled="wTrade.customers_cid === ''" v-else>
                      <i class="fa fa-ban mr-5"></i>{{'deactivate' | translate | capitalize}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-6">
              <div class="box box-primary">
                <div class="box-header with-border">
                  <i class="fa fa-truck mr-5"></i>Versandkosten
                </div>
                <div class="box-body">
                  <template v-if="shippingLoading">
                    <img class="wt-loading-gif" src="/static/img/blabla.svg"/>
                  </template>
                  <template v-else>
                    <div class="row mb-10">
                      <div class="col-xs-12">
                        <div class="input-group" style="width: 100%;">
                          <div class="input-group-addon">
                            <span>{{'shipping_price' | translate}}</span>
                          </div>
                          <input type="text" class="form-control" :disabled="posting" v-validate="{required: true, regex: /^\d+([\,]\d+)*([\.]\d+)?$/}" data-vv-as="Versandkosten" data-vv-scope="shippingInfo" name="price" v-model="company.shipping_price">
                        </div>
                        <span v-show="errors.has('shippingInfo.price')" class="small text-danger">{{ errors.first('shippingInfo.price') }}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-12">
                        <div class="input-group" style="width: 100%;">
                          <div class="input-group-addon">
                            <span>{{'shipping_free' | translate}}</span>
                          </div>
                          <input type="text" class="form-control" v-validate="{required: true, regex: /^\d+([\,]\d+)*([\.]\d+)?$/}" :disabled="posting" v-model="company.shipping_free" name="shipping" data-vv-as="Versandkostenfrei ab" data-vv-scope="shippingInfo">
                        </div>
                        <span v-show="errors.has('shippingInfo.shipping')" class="small text-danger">{{ errors.first('shippingInfo.shipping') }}</span>
                      </div>
                    </div>
                  </template>
                </div>
                <div class="box-footer" v-if="!shippingLoading">
                  <div class="col-xs-12 text-right pull-right">
                    <button @click="postMS" class="btn btn-flat btn-success" :disabled="errors.any('shippingInfo') || posting || company.shipping_price === 'Nicht gesetzt' || company.shipping_free === 'Nicht gesetzt'">
                      <i :class="['fa mr-5', posting? 'fa-spinner fa-spin' : 'fa-check']"></i>{{'save' | translate | capitalize}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title"><i class="fa fa-gears mr-5"></i>{{'basic_info' | translate}}</h3>
          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
          </div>
        </div>
        <div class="box-body">
          <template v-if="fullLoading">
            <div class="row">
              <div class="col-xs-12 text-center">
                <img class="loading-gif" src="/static/img/blabla.svg"/>
              </div>
            </div>
          </template>
          <template v-else>
          <div class="row">
            <div class="col-xs-12">
              <strong>ERP:</strong>
            </div>
            <div class="col-xs-8">
              <div class="form-group">
                <select disabled data-vv-as="ERP ID" data-vv-scope="erp" :class="{'form-control': true, 'form-control-danger': errors.has('erp.erp_system_id') }" name="erp_system_id" v-model="basicConf.erp_system_id">
                  <template v-for="erp in erpSystems">
                    <option class="normal" :value="erp.id">{{erp.name}}</option>
                  </template>
                </select>
                <span v-show="errors.has('erp.erp_system_id')" class="small text-danger">{{ errors.first('erp.erp_system_id') }}</span>
              </div>
            </div>
            <div class="col-xs-4">
              <router-link :to="`/accounting/companies/${company.id}/config/erp`">
                <button class="btn btn-flat btn-primary pull-right" @click="$store.commit('updateCompanyErpNameHelper', company.erp_system), $store.commit('updateCompanyErpIdHelper', company.erp_system_id)">
                  <i class="fa fa-cogs mr-5"></i> {{'edit' | translate}}
                </button>
              </router-link>
            </div>
          </div>
          <hr>
          <div class="row mb-10">
            <div class="col-xs-12">
              Abrechnungsfiliale (Storenumber):<br/><strong>{{basicConf.creditor_number}}</strong>
              <hr>
              SAP Number:<br/><strong>{{basicConf.sap_number}}</strong>
              <hr>
              Shipcloud Key:<br/><strong>{{basicConf.shipcloud_key}}</strong>
              <hr>
              Bestell Email:<br/><strong>{{basicConf.qb_email}}</strong>
              <hr>
              <div class="row">
                <div class="col-xs-6">
                  Rating:<br/><strong>{{basicConf.ranking}}</strong>
                </div>
                <div class="col-xs-6">
                  Ratingbonus<br/><strong>{{basicConf.ranking_base}}</strong>
                </div>
              </div>
              <hr>
              <span class="mr-5">Zusätzliche Email an Filiale:</span>
              <div class="btn-group btn-group-sm" data-toggle="btn-toggle" v-model="active">
                <button  type="button" :class="['btn btn-success btn-flat no-margin', basicConf.send_mail_to_branch ? 'active' : 'hidden']"><i class="fa fa-check mr-5"></i>{{'active' | translate}}</button>
                <button  type="button" :class="['btn btn-danger btn-flat no-margin', !basicConf.send_mail_to_branch ? 'active' : 'hidden']"><i class="fa fa-ban mr-5"></i>{{'inactive' | translate}}</button>
              </div>
            </div>
          </div>
          </template>
        </div>
        <div class="box-footer">
          <div class="row">
            <div class="col-xs-12">
              <button data-toggle="collapse" data-target="#basic_settings" type="button" class="btn btn-flat no-margin pull-right btn-info"><i class="fa fa-edit mr-5"></i>{{'edit' | translate}}</button>
            </div>
          </div>
          <div id="basic_settings" class="collapse">
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label for="creditor_number">Abrechnungsfiliale (Storenumber):</label>
                  <input class="form-control" placeholder="Abrechnungsfiliale" name="creditor_number" v-model="basicConf.creditor_number">
                </div>
              </div>
              <div class="col-xs-12">
                <div class="form-group">
                  <label for="sap_number">SAP Number:</label>
                  <input class="form-control" placeholder="SAP Number" name="sap_number" v-model="basicConf.sap_number">
                </div>
              </div>
              <div class="col-xs-12">
                <div class="form-group">
                  <label for="shipcloud_key">Shipcloud Key:</label>
                  <input data-vv-as="Shipcloud Key" data-vv-scope="erp" class="form-control" name="shipcloud_key" placeholder="Shipcloud Key" type="text" v-model="basicConf.shipcloud_key">
                  <span v-show="errors.has('erp.shipcloud_key')" class="small text-danger">{{ errors.first('erp.shipcloud_key') }}</span>
                </div>
              </div>
              <div class="col-xs-12">
                <div class="form-group">
                  <label for="qb_email">Bestell Email:</label>
                  <input v-validate="'required|email'" data-vv-scope="erp" data-vv-as="QB Email" class="form-control" name="qb_email" placeholder="QB Email" type="text" v-model="company.qb_email">
                  <span v-show="errors.has('erp.qb_email')" class="small text-danger">{{ errors.first('erp.qb_email') }}</span>
                </div>
              </div>
              <div class="col-xs-12">
                <div class="form-group">
                  <label for="ranking_base">Ratingbonus:</label>
                  <input class="form-control" placeholder="Ratingbonus" name="ranking_base" type="number" v-model="basicConf.ranking_base">
                </div>
              </div>
              <div class="col-xs-12">
                <div class="form-group">
                  <label for="send_mail_to_branch">Email an Filiale:</label>
                  <select class="form-control" name="send_mail_to_branch" v-model="basicConf.send_mail_to_branch">
                    <option class="normal" value="1">Ja</option>
                    <option class="normal" value="0">Nein</option>
                  </select>
                </div>
              </div>
              <div class="col-xs-12 text-right pull-right">
                <button :disabled="errors.any('erp')" @click="postData(basicConf)" class="btn btn-flat btn-success">
                  <i class="fa fa-save mr-5"></i>{{'submit' | translate | capitalize}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  export default {
    props: ['company', 'fullLoading'],
    data () {
      return {
        posting: false,
        loading: {
          phone: false,
          mail: false
        },
        toggle: {
          phone: false,
          mail: false
        },
        feesLoading: true,
        wTLoading: true,
        shippingLoading: true,
        shippingCost: 0,
        unShippingCost: 0,
        wTrade: {},
        type: 'barcode',
        active: 'true',
        submitObject: {},
        companyCopy: {},
        erpSystems: [{id:2, name:'Ipos '}, {id:4, name:'His '}, {id:5, name:'Bits '}, {id:7, name:'Etos'}, {id:6, name:'Webservice '}],
        placeholder: '',
        isNew: false,
        extensions: {},
        selected: 0,
        selectedType: 'code39',
        moment: moment,
        regex: {
          code39: '^[A-Z\\d-. $\/+%*]*$',
          code93: '^[\\dA-Z-. $\/+%]*$',
          code128: '^[A-z\\d\\] !"#$%&\'()*+,-./:;<=>?@[^_`{|}~]*$'
        },
        barcodeChar: '',
        placeholders: [
          {id: 1, label: 'selling_price'},
          {id: 2, label: 'order_id'},
          {id: 3, label: 'order_id_ext'},
          {id: 4, label: 'sales_channel'},
          {id: 5, label: 'ean'},
          {id: 6, label: 'erp_article_number'},
          {id: 7, label: 'erp_article_id'},
          {id: 8, label: 'erp_article_id_secondary'},
          {id: 9, label: 'erp_size_index'},
          {id: 10, label: 'erp_size_text'},
          {id: 11, label: 'erp_color_text'}
        ]
      }
    },
    methods: {
    	customLabel ({label}) {
    		return `${this.$options.filters.translate(label, this.$store.getters.language)}`
      },
    	check (e) {
    		if(e.keyCode !== 8 && e.keyCode < 37 || e.keyCode > 40) {
    			e.preventDefault()
        }
      },
      resetBarcode () {
        this.$emit('update', {barcode_content: '', barcode_type: 'code39'})
      },
    	buildString (option, id) {
    		if (!this.errors.any('barcodeForm') && option.label !== '') {
          this.company.barcode_content += id === 0? this.company.barcode_content.length === 0 ? option.label : '-' + option.label : this.company.barcode_content.length === 0? '#' + option.label + '#' : '-#' + option.label + '#'
        }
      },
      updateData (data) {
    	  this.barcodeChar = ''
        this.$emit('update', data)
      },
      postData (data) {
        //this.compareAndGetDifferences()
        API.put(`accounting/companies/${this.company.id}`, data)
          .then(response => {
          this.$emit('update', response)
        })
          .catch(error => { this.$emit('update', 'error') })
      },
      sendEdit (id, store, key) {
        this.loading[key] = true
        API.put(`accounting/companies/${id}`, store)
          .then(response =>{
            let alert = {dismiss: 4, type: 'success', message: 'Update Successful'}
            this.$store.commit('pushAalert', alert)
            this.loading[key] = false
            this.toggle[key] = false
          })
          .catch(error =>{
            if (this.$parent.checkError(error)) {
              error = error.response.data.error
              this.loading[key] = false
              this.toggle[key] = false
              this.$store.commit('pushAlert', {type: 'danger', dismiss: 4, message: error.message})
            }
          })
      },
      create () {
        let ext
        if (this.company.erp_system === 'his') {
          ext = {
            sales_channel_id: '',
            shipping_cost_id: '',
            payment_id: '',
            ishop: ''
          }
          this.extensions.push(ext)
        } else {
          ext = {
            sales_channel_id: '',
            selling_store_id: ''
          }
          this.extensions.push(ext)
        }
      },
	    getUrl (url) {
    		if (typeof url !== 'undefined') {
			    return url.substr(0,7) === 'http://' || url.substr(0,8) === 'https://' ? url : `http://${url}`
		    }
		    return ''
	    },
      postWT (val) {
        this.wTLoading = true
        API.post(`accounting/companies/${this.company.id}/warentrading`, {customers_cid: this.wTrade.customers_cid, flag: val})
          .then(res => {
            this.wTrade.flag = val
            this.wTLoading = false
          })
          .catch(error => {
            this.wTLoading = false
          })
      },
      postMS () {
        this.posting = true
       /* Object.keys(copy).forEach(val => {
          copy[val] = copy[val] === '' ? 0 : copy[val].toString().replace(',', '.')
        })*/
        API.put(`accounting/companies/${this.company.id}`, {
          shipping_free: this.company.shipping_free === '' ? 0 : this.company.shipping_free.toString().replace(',', '.'),
          shipping_price: this.company.shipping_price === '' ? 0 : this.company.shipping_price.toString().replace(',', '.')
        })
          .then(res => {
            this.posting = false
          })
      }
    },
    computed: {
      basicConf () {
        return {
          creditor_number: this.company.creditor_number,
          sap_number: this.company.sap_number,
          shipcloud_key: this.company.shipcloud_key,
          qb_email: this.company.qb_email,
          ranking: this.company.ranking,
          ranking_base: this.company.ranking_base,
          send_mail_to_branch: this.company.send_mail_to_branch,
          erp_system_id: this.company.erp_system_id
        }
      },
      erpConf () {
        return {
          barcode_content: this.company.barcode_content,
          barcode_type: this.company.barcode_type
        }
      },
      companyInfo () {
        return {
          name: this.company.name,
          organisation_number: this.company.organisation_number,
          inv_company: this.company.inv_company,
          inv_first_name: this.company.inv_first_name,
          inv_last_name: this.company.inv_last_name,
          inv_street: this.company.inv_street,
          inv_postcode: this.company.inv_postcode,
          inv_city: this.company.inv_city,
          tax_number: this.company.tax_number,
          inv_email: this.company.inv_email,
          telephone: this.company.telephone,
          mobile: this.company.mobile,
          homepage: this.company.homepage,
          id: this.company.id,
          qb_phone_contact: this.company.qb_phone_contact,
          qb_email_contact: this.company.qb_email_contact,
        }
      }
    },
    watch: {
      company () {
	      this.config = false
	      this.type = 'barcode'
        if (this.$validator.validateAll()) {
          this.errors.clear('companyInfo')
          this.errors.clear('barcodeForm')
          this.errors.clear('shippingInfo')
          this.errors.clear('erp')
        }
        API.get(`accounting/companies/${this.company.id}/warentrading`)
          .then(res => {
            this.wTrade = res.data
            this.wTLoading = false
          })
        this.shippingLoading = false
        this.company.shipping_price = this.company.shipping_price !== null ? parseFloat(this.company.shipping_price).toFixed(2).replace('.', ',') : 'Nicht gesetzt'
        this.company.shipping_free = this.company.shipping_free !== null ? parseFloat(this.company.shipping_free).toFixed(2).replace('.', ',') : 'Nicht gesetzt'
      },
      config () {
      }
    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .italic {
    font-style: italic;
  }
  .wt-loading-gif {
    max-width: 152px;
    margin-left: 35%;
  }
</style>
<style>
  .multiselect, .multiselect__input, .multiselect__single, .multiselect--active {
    font-size: 14px !important;
    background: transparent !important;
    color: #ffffff !important;
    z-index: 3 !important;
  }
  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0px !important;
    border: 1px solid rgba(255,255,255,.15);
    color: #ffffff;
    background: transparent !important;
    font-size: 14px;
  }
  .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #212228;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid rgba(255,255,255,.15);
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 3 !important;
    -webkit-overflow-scrolling: touch;
  }
  .vdp-datepicker, .vdp-datepicker__calendar, .vdp-datepicker input {
    background-color: #202227 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/CompanyEdit.vue